import { alpha, height } from "@mui/system";

import { fonts, gutterX, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  iconSecao: {
    fontSize: "19px",
    color: theme.palette.primary.main,
  },
  botaoCopiarSecao: {
    fontSize: fonts.label,
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  textoLongo: {
    fontSize: fonts.reading,
    lineHeight: 1.6,
    whiteSpace: "pre-line",
    wordBreak: "break-word",
    minHeight: "40px",
  },
  textoVazio: {
    fontSize: fonts.body,
    fontStyle: "italic",
    color: theme.palette.text.disabled,
    p: 1,
  },
  boxChipCampo: {
    display: "flex",
    mt: 0.25,
  },
  boxResponsavel: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  nomeResponsavel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  paperContainer: {
    borderRadius: "16px",
    padding: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    overflow: "hidden",
  },
  containerHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  containerTitle: {
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    flex: 1,
    minWidth: 0,
    alignItems: "center",
  },
  boxCont: {
    ml: 1,
    px: 1,
    py: 0.2,
    fontSize: "0.75rem",
    fontWeight: 600,
    borderRadius: "12px",
    backgroundColor: "primary.main",
    color: "primary.contrastText",
    display: "inline-flex",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  cardDescricao: {
    fontSize: "13px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  chipBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  nameDescription: {
    fontWeight: 600,
    fontSize: fonts.label,
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    whiteSpace: "nowrap",
    flexShrink: 0, // Impede que o rótulo "Endereço:" encolha
  },
  valueDescription: {
    fontSize: fonts.body,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: 0, // ESSENCIAL: Permite que o flex item encolha abaixo do tamanho do texto
    flexGrow: 1, // Faz o valor ocupar o restante do espaço
  },
  containerDataDescription: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  chipPriority: {
    color: theme.palette.white.main,
    fontWeight: 600,
    fontSize: fonts.chip,
    height: "22px",
    borderRadius: radius.chip,
  },
  containerModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,

    height: "600px",
  },
  chipSla: {
    color: theme.palette.white.main,
    fontWeight: 600,
    fontSize: fonts.chip,
    borderRadius: radius.chip,
    height: "22px",
  },
  containerIconExist: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  titleModal: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "95%",
  },
  valueChip: {
    fontSize: "10px",
    fontWeight: "bold",
  },
  containerHeaderModal: {
    borderRadius: radius.panel,
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    top: 0,
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    px: gutterX,
    py: 2.5,
    gap: 1,
  },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "50px",
    px: gutterX,
  },
  boxBodyModal: { px: gutterX },
  containerBodyModal: {
    height: "80%",
    overflowY: "auto",
    pb: 2,
  },
  containerPaperModal: {
    width: "100%",

    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  titleChipModal: {
    fontWeight: 600,
    fontSize: fonts.chip,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDescription: {
    width: "100%",
    minHeight: "60px",
  },
  clearIcon: {
    fontSize: "20px",
    color: theme.palette.text.main,
  },
  buttonDetails: {
    width: "80%",
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  bodyMensagem: { padding: 2, display: "flex", gap: 2 },
  boxImg: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    maxWidth: "50px",
    maxHeight: "50px",
  },
  boxAnexo: {
    width: 100,
    height: 100,
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    cursor: "pointer",
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
  chipTypeAtendimento: {
    width: "180px",
    backgroundColor: theme.palette.colors.pink.medium,
    color: theme.palette.white.main,
  },
  containerTabs: {
    width: "100%",
    bgcolor: "background.paper",
    padding: "0 2%",
  },
  buttonAnexo: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "inline-flex",
    justifyContent: "flex-start",
  },
  boxWithoutImg: {
    width: 50,
    height: 50,

    display: "block",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    backgroundColor: theme.palette.cardTrafficData.paperColor.statusUp,
    fontWeight: "bold",
    color: theme.palette.white.main,
    marginLeft: 1,
    flexShrink: 0,
  },
  titleProtocolo: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  boxDescription: {
    display: "flex",
    gap: 1,
    width: "100%", // Garante que o box use o espaço disponível
    overflow: "hidden", // Segurança extra
  },
  description: {
    fontSize: "13px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontWeight: "regular",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.light
        : theme.palette.colors.black.medium,
  },
  containerInfo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyItems: "center",
  },

  icon: {
    fontSize: "20px",
  },
  boxIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  boxFluxo: {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  iconStatus: { fontSize: "13px" },
  titleStatusCard: {
    fontSize: "9px",
    fontWeight: 900,
    color: theme.palette.white.main,
  },
  containerButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
  },
  boxInfos: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
});

export default styles;
